import { Action } from '../actions/fuels';
import { mapToReducer } from '../../lib/utils';

const defaultState = {
  isFetchingStation: {},
  fuelsByStationId: {},
  error: undefined,
};

export const mergeFuels = (fuelsMap, fuels) => fuels.reduce((map, f) => ({
  ...map,
  [f.stationId]: {
    ...map[f.stationId],
    [f.fuelType]: f,
  },
}), fuelsMap);

const getStationIds = meta => ((meta.station_id ? [meta.station_id] : meta.stationIds) || []);

export default function fuelsReducer(state = defaultState, action) {
  const body = action?.payload;

  switch (action?.type) {
    case Action.Fuels.FuelsCompleted:
      return {
        ...state,
        isFetchingStation: getStationIds(action.meta).reduce(
          mapToReducer(false),
          { ...state.isFetchingStation },
        ),
        fuelsByStationId: mergeFuels(state.fuelsByStationId, body.fuels),
      };

    case Action.Fuels.FuelsFailed:
      return {
        ...state,
        error: body,
        isFetchingStation: getStationIds(action.meta).reduce(
          mapToReducer(false),
          { ...state.isFetchingStation },
        ),
      };

    case Action.Fuels.FuelsPending:
      return {
        ...state,
        error: undefined,
        isFetchingStation: getStationIds(action.meta).reduce(
          mapToReducer(true),
          { ...state.isFetchingStation },
        ),
      };

    default:
      return state;
  }
}
